import React from "react";
import Select from "react-select";
import { useInbox } from "../../contexts/inbox";

const InboxGroupSelector = () => {
  const { 
    selectedGroupId, 
    groupInboxes, 
    inboxId, 
    inbox, 
    setSearchParams, 
    setSelectedFishThread, 
    setThreads, 
    setIsNewMessageOpen 
  } = useInbox();
  
  if (!selectedGroupId) return null;
  
  return (
    <div className="mt-3">
      <Select
        options={[
          // Add "All inboxes" option at the top
          {
            value: "all",
            label: "All inboxes"
          },
          // Then show individual inboxes
          ...groupInboxes.map(inbox => ({
            value: inbox.id,
            label: inbox.user && inbox.user.name
              ? `${inbox.user.name} (${inbox.phoneNumber || inbox.email || "No contact info"})`
              : inbox.phoneNumber || inbox.email || `Inbox ${inbox.id}`
          }))
        ]}
        value={
          inboxId && groupInboxes.find(i => i.id === inboxId) && inbox
            ? {
                value: inboxId,
                label: inbox.user && inbox.user.name
                  ? `${inbox.user.name} (${inbox.phoneNumber || inbox.email || "No contact info"})`
                  : inbox.phoneNumber || inbox.email || `Inbox ${inboxId}`
              }
            : { value: "all", label: "All inboxes" }
        }
        onChange={(selectedOption) => {
          if (selectedOption.value === "all") {
            // Check if we're already on "All inboxes" view (no inboxId and has groupId)
            if (!inboxId && selectedGroupId) {
              // Already on "All inboxes" view, do nothing
              return;
            }
            
            // Not on "All inboxes" view, proceed with normal logic
            setSearchParams({ groupId: selectedGroupId });
            setSelectedFishThread(null);
            setThreads([]);
            setIsNewMessageOpen(false);
          } else {
            // Check if already on this inbox
            if (inboxId === selectedOption.value) {
              // Already on this inbox, do nothing
              return;
            }
            
            // Normal inbox selection
            setSearchParams({ groupId: selectedGroupId, inboxId: selectedOption.value });
            setSelectedFishThread(null);
            setThreads([]);
            setIsNewMessageOpen(false);
          }
        }}
        className="basic-single"
        classNamePrefix="select"
        placeholder="Select an inbox from this group..."
        isSearchable={true}
      />
    </div>
  );
};

export default InboxGroupSelector;
